export default "__VITE_ASSET__CgBR_Y0m__"